import { render } from "./DevelopersHcCard.vue?vue&type=template&id=1fd33008&scoped=true"
import script from "./DevelopersHcCard.vue?vue&type=script&lang=js"
export * from "./DevelopersHcCard.vue?vue&type=script&lang=js"

import "./DevelopersHcCard.vue?vue&type=style&index=0&id=1fd33008&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fd33008"]])

export default __exports__